import React from 'react';
import PropTypes from 'prop-types';
import './makerCheckerView.scss';

const getMaskedAccountNo = accountNo => {
    if (!accountNo) {
        return '';
    }
    return accountNo.slice(0, -4).replace(/\d/g, 'X') + accountNo.slice(-4);
};

const getStatus = status => {
    if (status === 1) {
        return 'Active';
    }
    if (status === 2) {
        return 'Inactive';
    }
    return 'Inactive with settlement';
};

const TerminalView = props => {
    const { data, count } = props;
    return (
        <>
            <div className="checker-section-container">
                <h1 className="checker-section-title">Terminal Data</h1>
                <div className="form-section">
                    <div className="form-field">
                        <p className="label">Terminal Name</p>
                        <p className="user-text">{data.terminalName}</p>
                    </div>
                    <div className="form-field">
                        <p className="label">Merchant Category</p>
                        <p className="user-text">{data.paymentCategory}</p>
                    </div>
                    <div className="form-field">
                        <p className="label">Payment Mode</p>
                        <p className="user-text">{data.paymentMode}</p>
                    </div>
                    {data.email && (
                        <div className="form-field">
                            <p className="label">Email</p>
                            <p className="user-text">{data.email}</p>
                        </div>
                    )}
                    <div className="form-field">
                        <p className="label">Settlement Account</p>
                        <p className="user-text">
                            {getMaskedAccountNo(data.settlementAccountRefence)}
                        </p>
                    </div>
                    <div className="form-field">
                        <p className="label">Terminal Status</p>
                        <p className="user-text">{getStatus(data.status)}</p>
                    </div>
                    {count && (
                        <div className="form-field">
                            <p className="label">Terminal Count</p>
                            <p className="user-text">{data.terminalCount}</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

TerminalView.propTypes = {
    data: PropTypes.object,
    count: PropTypes.number,
};

export default TerminalView;
